// extracted by mini-css-extract-plugin
export default {"wrapper":"GiftCardsPersonalise_wrapper__N7z8b","submit_error":"GiftCardsPersonalise_submit_error__H6Gn6"};